import { fg } from '@atlaskit/platform-feature-flags';

import type { SearchResult } from '../../../../common/types';

const SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		uuid
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;

export interface SearchResultMercuryFocusArea extends SearchResult {
	lastModifiedDate?: string;
	focusArea?: {
		id: string;
		uuid: string;
		name: string;
		focusAreaType: {
			id: string;
			name: string;
			hierarchyLevel: number;
		};
		status: {
			key: string;
			displayName: string;
		};
		health?: {
			key: string;
			color: string;
			displayName: string;
		};
		targetDate?: {
			targetDate: string;
			targetDateType: string;
		};
		owner?: {
			accountId: string;
			name: string;
		};
	};
	__typename: 'SearchResultMercuryFocusArea';
}

const SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;

export interface SearchResultMercuryFocusAreaStatusUpdate extends SearchResult {
	lastModifiedDate?: string;
	focusArea?: {
		name: string;
	};
	__typename: 'SearchResultMercuryFocusAreaStatusUpdate';
}

const SearchResultSpfAskPartial = `
... on SearchResultSpfAsk {
	lastModifiedDate
	ask @optIn(to: "Spf") {
		id
		name
	}
}
`;

export interface SearchResultSpfAsk extends SearchResult {
	lastModifiedDate?: string;
	ask?: {
		id: string;
		name: string;
	};
	__typename: 'SearchResultSpfAsk';
}

export type SearchMercuryPartial =
	| SearchResultMercuryFocusArea
	| SearchResultMercuryFocusAreaStatusUpdate
	| SearchResultSpfAsk;

export const isSearchResultMercuryFocusAreaPartial = (
	partial: SearchResult,
): partial is SearchResultMercuryFocusArea => {
	return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};

export const isSearchResultMercuryFocusAreaStatusUpdatePartial = (
	partial: SearchResult,
): partial is SearchResultMercuryFocusAreaStatusUpdate => {
	return (
		partial?.id?.includes('mercury') &&
		partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate'
	);
};

export const isSearchResultSpfAskPartial = (
	partial: SearchResult,
): partial is SearchResultSpfAsk => {
	return partial?.id?.includes('passionfruit') && partial.__typename === 'SearchResultSpfAsk';
};

export const isSearchMercuryPartial = (partial: SearchResult): partial is SearchMercuryPartial => {
	return (
		isSearchResultMercuryFocusAreaPartial(partial) ||
		isSearchResultMercuryFocusAreaStatusUpdatePartial(partial) ||
		isSearchResultSpfAskPartial(partial)
	);
};

export const getMercuryPartials = () => {
	return `
		${SearchResultMercuryFocusArea}
		${SearchResultMercuryFocusAreaStatusUpdate}
		${fg('platform_passionfruit_search_onboarding_enabled') ? SearchResultSpfAskPartial : ''}
	`;
};
